module.exports = __webpack_public_path__ + "img/logout.9ca620ea.png";